import React from 'react'
import { IoLogoNodejs } from 'react-icons/io5';
import { IconProps } from '../types';



export const NodeIcon = (props: IconProps) => {
    return (
        <IoLogoNodejs {...props} />
    )
}


NodeIcon.displayName = "NodeIcon"
